import i18n from 'i18n'
import * as Yup from 'yup'
import { PASSWORD_VALIDATORS } from '@/constants/regex'

export type ValidationStringProps = {
  required?: boolean
  min?: number
  max?: number
}

export type ValidationNumberProps = {
  required?: boolean
  integer?: boolean
  max?: number
  min?: number
}

export const getValidationString = ({
  required,
  max,
  min,
}: ValidationStringProps) => {
  let validateString = Yup.string().trim()
  if (required) {
    validateString = validateString.required(i18n.t('error.requiredField'))
  }
  if (max !== undefined) {
    validateString = validateString.max(max, ({ max }) =>
      i18n.t('error.maxCharacters', { max }),
    )
  }
  if (min !== undefined) {
    validateString = validateString.min(min, ({ min }) =>
      i18n.t('error.minCharacters', { min }),
    )
  }
  return validateString
}

export const getValidatePassword = (required: boolean) => {
  const requiredString = Yup.string().required(i18n.t('error.requiredField'))

  let validations = Yup.string().trim()
  if (required) {
    validations = requiredString
  }

  return validations
    .matches(PASSWORD_VALIDATORS[0].regExp, PASSWORD_VALIDATORS[0].error)
    .matches(PASSWORD_VALIDATORS[1].regExp, PASSWORD_VALIDATORS[1].error)
    .matches(PASSWORD_VALIDATORS[2].regExp, PASSWORD_VALIDATORS[2].error)
    .matches(PASSWORD_VALIDATORS[3].regExp, PASSWORD_VALIDATORS[3].error)
    .matches(PASSWORD_VALIDATORS[4].regExp, PASSWORD_VALIDATORS[4].error)
}
